import { render, staticRenderFns } from "./qishijihuo.vue?vue&type=template&id=6ede5cf8&scoped=true&"
import script from "./qishijihuo.vue?vue&type=script&lang=js&"
export * from "./qishijihuo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ede5cf8",
  null
  
)

export default component.exports